import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Span } from '@sentry/react';

let refs: {
	span: Span;
	startAt: number;
	finishSpan: () => void;
} | null = null;

type SpanExtraType = Record<string, number | string>;

const startSpan = (route: string, extra?: SpanExtraType) => {
	try {
		refs?.finishSpan();
		refs = null;
	} catch {}
	refs = null;
	Sentry.startSpanManual(
		{ name: `Web Nav [${route}]`, op: 'navigation', attributes: { route, ...(extra ?? {}) } },
		async (span, finish) => {
			refs = {
				span,
				finishSpan: finish,
				startAt: Date.now(),
			};
		}
	);
};

export const endSpan = (extra?: SpanExtraType) => {
	if (refs === null) return;
	const durationMs = Date.now() - refs.startAt;

	try {
		refs.span?.setAttribute?.('RENDER_DURATION', durationMs);
		if (extra) {
			Object.entries(extra).forEach(([k, v]) => refs.span?.setAttribute?.(k, v));
		}
		refs.span?.end?.();
	} finally {
		refs.finishSpan();
		refs.span = null;
	}
};

export const fallbackSpan = (extra?: SpanExtraType) => {
	if (!refs || !refs.span) return;

	const durationMs = Date.now() - refs.startAt;

	refs.span.addEvent('FALLBACK_SHOWN');

	refs.span.setAttribute?.('START_TO_FALLBACK_DURATION', durationMs);
	if (extra) {
		Object.entries(extra).forEach(([k, v]) => refs.span?.setAttribute?.(k, v));
	}
};

export const useSpanSentry = () => {
	const location = useLocation();

	useEffect(() => {
		const url = window.location.href;
		startSpan(location.pathname, { reason: 'LOAD_START', url, pathname: location.pathname });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.key]);
};
